import { useEffect } from 'react';
import { debounce } from 'lodash';

const DEFAULT_WAIT = 100;

function useResizeObserver({ callback, containerRef, wait = DEFAULT_WAIT }) {
  useEffect(() => {
    const debouncedCallback = debounce(callback, wait);
    const resizeObserver = new ResizeObserver(debouncedCallback);

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [callback, containerRef]);
}

export default useResizeObserver;
